(function() {
  'use strict';
  
  // Só executa se estivermos na página de favoritos
  if (!window.location.pathname.includes('/pages/favoritas')) {
    return;
  }
  
  console.log('🎯 Script wishlist-page.js carregado');
  
  const WISHLIST_KEY = 'shopifyWishlist';
  
  function initWishlistPage() {
    console.log('🚀 Iniciando initWishlistPage...');
    
    const loadingElement = document.getElementById('wishlist-loading');
    const emptyElement = document.getElementById('wishlist-empty');
    const gridElement = document.getElementById('wishlist-products-grid');
    
    if (!loadingElement || !emptyElement || !gridElement) {
      console.error('❌ Elementos da página não encontrados');
      return;
    }

    async function loadWishlistProducts() {
      console.log('🚀 Carregando produtos...');
      
      const favoriteHandles = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
      console.log('📦 Handles no localStorage:', favoriteHandles);
      
      if (favoriteHandles.length === 0) {
        showEmptyState();
        return;
      }

      try {
        const fetchPromises = favoriteHandles.map(handle =>
          fetch(`/products/${handle}?view=card`)
            .then(res => {
              if (!res.ok) throw new Error(`Product ${handle} not found`);
              return res.text();
            })
            .catch(err => {
              console.warn(`Erro ao carregar produto ${handle}:`, err);
              return null;
            })
        );

        const htmlResults = await Promise.all(fetchPromises);
        const validProducts = htmlResults.filter(html => html !== null);
        
        const invalidCount = htmlResults.length - validProducts.length;
        if (invalidCount > 0) {
          const validHandles = favoriteHandles.filter((handle, index) => htmlResults[index] !== null);
          localStorage.setItem(WISHLIST_KEY, JSON.stringify(validHandles));
          console.log(`${invalidCount} produto(s) removido(s)`);
        }

        if (validProducts.length === 0) {
          showEmptyState();
          return;
        }

        renderProducts(validProducts);
        initializeWishlistButtons();
        
        console.log('✅ Produtos renderizados:', validProducts.length);

      } catch (error) {
        console.error('❌ Erro:', error);
        showEmptyState();
      }
    }

    function renderProducts(productsHtml) {
      loadingElement.style.display = 'none';
      gridElement.style.display = 'grid';
      gridElement.innerHTML = '';
      
      productsHtml.forEach(html => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html.trim();
        const productCard = tempDiv.querySelector('product-card');
        
        if (productCard) {
          gridElement.appendChild(productCard);
        }
      });
    }

    function showEmptyState() {
      loadingElement.style.display = 'none';
      emptyElement.style.display = 'block';
      gridElement.style.display = 'none';
    }

    function initializeWishlistButtons() {
      const buttons = document.querySelectorAll('.produto-favorito-btn');
      const favoriteHandles = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
      
      buttons.forEach(button => {
        const handle = button.dataset.productHandle;
        
        if (favoriteHandles.includes(handle)) {
          button.classList.add('ativo');
        }
        
        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          toggleWishlistItem(button);
        });
      });
    }

    function toggleWishlistItem(button) {
      const handle = button.dataset.productHandle;
      let favoriteHandles = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
      const productCard = button.closest('product-card');
      
      if (favoriteHandles.includes(handle)) {
        favoriteHandles = favoriteHandles.filter(h => h !== handle);
        localStorage.setItem(WISHLIST_KEY, JSON.stringify(favoriteHandles));
        
        window.dispatchEvent(new CustomEvent('wishlist:updated', {
          detail: { handles: favoriteHandles, count: favoriteHandles.length }
        }));
        
        if (productCard) {
          productCard.classList.add('wishlist-item-removing');
          
          setTimeout(() => {
            productCard.remove();
            
            const remainingCards = gridElement.querySelectorAll('product-card');
            if (remainingCards.length === 0) {
              showEmptyState();
            }
          }, 300);
        }
        
      } else {
        favoriteHandles.push(handle);
        localStorage.setItem(WISHLIST_KEY, JSON.stringify(favoriteHandles));
        
        window.dispatchEvent(new CustomEvent('wishlist:updated', {
          detail: { handles: favoriteHandles, count: favoriteHandles.length }
        }));
        
        button.classList.add('ativo');
      }
      
      document.querySelectorAll(`.produto-favorito-btn[data-product-handle="${handle}"]`).forEach(btn => {
        btn.classList.toggle('ativo', favoriteHandles.includes(handle));
      });
    }

    loadWishlistProducts();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistPage);
  } else {
    setTimeout(initWishlistPage, 100);
  }
  
  document.addEventListener('turbo:load', initWishlistPage);
})();